const translations = {
  "renew.title": "Reactivate Subscription",
  "renew.error.generic": "Your payment could not be completed at this time. Please double-check your card details or add a new one to reactivate your subscription.",
  "renew.error.expired": "Your payment could not be completed at this time. It seems your card has expired. Please add a new card to get your subscription back up and running.",
  "renew.card.digits": "Ending in {last4}",
  "renew.card.expires": "Expires {expiration}",
  "renew.card.expired": "Expired",
  "renew.card.failed": "Failed",
  "renew.success.first": "Membership activated",
  "renew.success.btn": "Continue",
  "renew.error.first": "We couldn't process your payment",
  "renew.error.second": "Please review your payment details and try again.",
  "renew.error.btn": "Try again",
  "renew.new.card.title": "Pay with new card"
};

export default translations;